import React from 'react';
import { Link } from 'react-router-dom';

export default ({ value, id }) => <Link to={'/groups/' + id}> {value} </Link>;
